import clsx from 'clsx';
import { FunctionComponent } from 'react';
import { WizardStepTree } from '../../interfaces/wizard-step';
import styles from './WizardHeaderStep.module.scss';
import { wizardHeaderStepDataIds } from './data-ids';
import { WizardHeaderStepProgress } from '../WizardHeaderStepProgress/WizardHeaderStepProgress';

export interface WizardHeaderStepProps {
  step: WizardStepTree;
  progress: number;
  onSelect: VoidFunction;
  index: number;
  Extra?: FunctionComponent<object>;
  extraProps?: object;
  disabled: boolean;
}

export function WizardHeaderStep({
  step,
  progress,
  onSelect,
  index,
  Extra,
  disabled,
  extraProps = {}
}: WizardHeaderStepProps) {
  const active = progress >= 0 && progress < 1;
  const completed = progress === 1;

  return (
    <button
      type='button'
      className={clsx(
        styles.wizardHeaderStep,
        active && styles.active,
        'center-flex-col justify-center wizard-header-step'
      )}
      onClick={() => {
        if (completed) {
          onSelect();
        }
      }}
      disabled={disabled}
      aria-disabled={disabled}
      data-id={wizardHeaderStepDataIds.container}
    >
      <WizardHeaderStepProgress stepCount={index + 1} active={active} completed={completed} />

      <span
        className={clsx('text-center mt-1 text-medium', active && 'text-primary')}
        data-content={step.title}
        data-id={wizardHeaderStepDataIds.title}
      >
        {step.title}
      </span>

      {Extra ? (
        <div className={clsx(styles.wizardHeaderStepExtra, active && 'text-primary')}>
          <Extra {...extraProps} />
        </div>
      ) : null}
    </button>
  );
}
